import { ANNIVERSARY_ORDER_ITEMS, getAnniversaryQuestionIds } from './shirt-anniversary-spec';
import { getShirtQuestionIds } from './shirt-ids';
import type { ShirtLineQuantityPayload } from './shirt-sizes';
import { buildShirtSizeIdGroup, parseAnswersToShirtQuantities } from './shirt-sizes';

function anniversaryPayloadType(row: (typeof ANNIVERSARY_ORDER_ITEMS)[number]): string {
  if (row.year <= 4) return 'Anniversary T-shirts';
  if (row.year === 5) return 'Anniversary Polo';
  if (row.year === 6) return 'Anniversary Crewneck';
  if (row.year === 7) return 'Anniversary Half Zip Sweater';
  return 'Anniversary Jacket';
}

export function buildShirtsPayloadFromAnswers(
  questionAnswers: Record<string, string>,
  prefix: string,
): Array<
  {
    type: string;
    model?: string;
  } & ShirtLineQuantityPayload
> {
  const ids = getShirtQuestionIds(prefix);
  const tSizes = buildShirtSizeIdGroup(prefix, 't');
  const poloSizes = buildShirtSizeIdGroup(prefix, 'polo');
  const shirts: Array<{ type: string; model?: string } & ShirtLineQuantityPayload> = [];
  const month = questionAnswers[ids.month];

  if (questionAnswers[ids.monthlyYn] === 'Yes' && month) {
    shirts.push({
      type: 'T-Shirts',
      model: month,
      ...parseAnswersToShirtQuantities(questionAnswers, tSizes),
    });
  }

  if (questionAnswers[ids.poloYn] === 'Yes') {
    shirts.push({
      type: 'Polo Shirts',
      ...parseAnswersToShirtQuantities(questionAnswers, poloSizes),
    });
  }

  for (const row of ANNIVERSARY_ORDER_ITEMS) {
    const a = getAnniversaryQuestionIds(prefix, row.slug, row.requiresColor);
    if (questionAnswers[a.yn] !== 'Yes') continue;
    let model = row.product;
    if (row.requiresColor) {
      const color = a.color ? questionAnswers[a.color]?.trim() : '';
      if (!color) continue;
      model = `${row.product} (${color})`;
    }
    shirts.push({
      type: anniversaryPayloadType(row),
      model,
      ...parseAnswersToShirtQuantities(questionAnswers, buildShirtSizeIdGroup(prefix, row.slug)),
    });
  }

  return shirts;
}
